var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exchange-rate-download-form',{attrs:{"date":_vm.date,"currencies":_vm.currenciesForDownload},on:{"on-show-popup":_vm.getCurrencies,"on-technical-error":_vm.setTechnicalError}})
}
var staticRenderFns = []

export { render, staticRenderFns }